<template>
  <div class="itemInner">
    <div class="itemInfo notranslate toCapitalize">
      <div class="subject" :class="{cancelledItem: cancelledShopItems && cancelledShopItems.mainItem}">
        <span v-if="itemData.status" class="shopItemStatus">{{ locale[`status_${itemData.status}`] }}</span>
        {{ item.main[0].shopItemName[lang] }}
        <span v-if="cancelledShopItems && cancelledShopItems.mainItem" class="cancelMessage">({{ datetimeFormat(cancelledShopItems.mainItem.cancellat) }} 취소됨)</span>
      </div>
    </div>
    <div class="itemOption">
      <div v-if="item.options && item.options.length" class="optionInfo">
        <div class="list">
          <div
            v-for="(order, index) in item.options"
            :key="index">
            <div class="row">
              <span class="label">{{order.optName[lang] || ''}}</span>
              <div class="value">
                <span
                  v-for="(opt, index) in order.selectOptItem"
                  :key="index"
                  class="valueArr"
                  :class="{cancelledItem: isCancelledOption(opt.shopItemId)}">
                  {{ opt.name[lang] }}
                  {{ opt.priceInfo && opt.priceInfo.gross ? `(${priceFormat(opt.priceInfo.gross)})` : '' }}
                  {{ ` * ${opt.quantity}` }}
                  <span v-if="isCancelledOption(opt.shopItemId)"
                    class="cancelMessage">
                    ({{ datetimeFormat(isCancelledOption(opt.shopItemId).cancellat) }} {{ locale.cancel }})
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="itemData.priceInfo" class="priceInfo notranslate priceDpBoard">
        <div v-if="item.main[0].priceInfo.gross > 0" class="item priceDpBoard">
          <span class="label toCapitalize">{{locale.summary_unitprice}}</span>
          <span class="value">{{priceFormat(item.main[0].priceInfo.gross)}}</span>
        </div>
        <!-- <div v-if="priceOption.length" class="priceDpBoard">
          <div class="item"
            v-for="(info, index) in priceOption"
            :key="index">
            <div class="label toCapitalize">
              <span v-if="!isAmenity">[{{locale.option_price}}]</span>
              {{!isAmenity ? info.label : amenityName(info)}}
              <span v-if="info.quantity">({{info.quantity}})</span>
            </div>
            <div class="value">{{priceFormat(info.price)}}</div>
          </div>
        </div> -->
        <div class="item">
          <span class="label toCapitalize">{{locale.quantity}}</span>
          <span class="value">{{item.quantity}}</span>
        </div>
        <div class="item price priceDpBoard">
          <div class="label toCapitalize">{{locale.total}}</div>
          <div class="value">
            {{priceFormat(item.totalPriceInfo.totalPrice)}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import regExp from '@/common/regExp'

export default {
  name: 'OrderShopItem',
  props: [
    'itemData',
    'lang',
    'locale',
    'localeAmenity',
    'noLink',
    'isTip'
  ],
  computed: {
    item () {
      return this.itemData && this.itemData.itemOrderSheet
    },
    format () {
      const setting = this.$store.state.common.setting
      const date = setting.dateFormat[setting.dateformatDefault]
      const time = 'HH:mm:ss'
      return `${date} ${time}`
    },
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    currencyCode () {
      return this.$store.getters['common/getSetting'].currency.toUpperCase()
    },
    /**
     * 선택한 항목 중 개별 취소 정보를 호출하기 위한 데이터
     * 센터에서 직접 취소하는 경우는 오더 자체가(orderListItem) 취소되는 것이라 여기에 해당되지 않음
     * 옵션만 취소, 또는 메인아이템만 취소되는 경우는 포스상 특정shopItemId를 취소하는 경우밖에 없음
     */
    cancelledShopItems () {
      const shopItems = this.item.selectShopItems || []
      const cancelledMain = shopItems.find(x => x.cancelled && x.mainMenu)
      const cancelledOption =  shopItems.filter(x => x.cancelled && !x.mainMenu)
      return {
        mainItem: cancelledMain,
        optionItem: cancelledOption
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    datetimeFormat (iso) {
      const datetime = DateTime.fromISO(iso, { zone: this.timezone })
      return datetime.toFormat(this.format)
    },
    priceFormat (price) {
      const code = this.currencyCode
      return regExp.priceFormat(`${price}`, code)
    },
    isCancelledOption (shopItemId) {
      if (!shopItemId) return
      const cancelledOption = this.cancelledShopItems && this.cancelledShopItems.optionItem
      return cancelledOption && cancelledOption.find(x => x.shopItemId === shopItemId)
    }
  }
}
</script>
